import Image from 'next/image';
import { nb } from '@/lib/nobreak';
import { Arrow, type BlogCardData } from './blog-shared';

const CARD_SIZES = '(min-width:1040px) 384px, (min-width:700px) 50vw, 100vw';
const FEAT_SIZES = '(min-width:900px) 640px, 100vw';

/** Hero image through the Next optimizer (small WebP at the real display width instead of the 70-160 KB source JPG).
 *  The featured card is the page's LCP: priority = eager + fetchpriority high + preload. Grid cards stay lazy. */
export function CardImage({ title, category, heroImage, priority = false, sizes = CARD_SIZES }: { title: string; category: string; heroImage?: string | null; priority?: boolean; sizes?: string }) {
  return (
    <div className="bp-pc-i">
      {heroImage ? (
        <Image src={heroImage} alt={title} fill sizes={sizes} quality={70} priority={priority} />
      ) : (
        <div className="bp-ph" aria-hidden="true"><span>{category}</span></div>
      )}
    </div>
  );
}

export function PostCard({ post, basePath }: { post: BlogCardData; basePath: string }) {
  return (
    <a className="bp-pc" href={`${basePath}/${post.slug}`}>
      <CardImage title={post.title} category={post.category} heroImage={post.heroImage} />
      <div className="bp-pc-b">
        <span className="bp-pc-k">{post.category}</span>
        <h3 className="bp-pc-t">{nb(post.title)}</h3>
        <p className="bp-pc-d">{nb(post.description)}</p>
        <div className="bp-pc-m"><span>{post.publishDate}</span><span>{post.readTime}</span></div>
      </div>
    </a>
  );
}

export function FeaturedCard({ post, basePath }: { post: BlogCardData; basePath: string }) {
  return (
    <a className="bp-feat" href={`${basePath}/${post.slug}`}>
      <CardImage title={post.title} category={post.category} heroImage={post.heroImage} priority sizes={FEAT_SIZES} />
      <div className="bp-feat-b">
        <span className="bp-pc-k">Latest &middot; {post.category}</span>
        <h2 className="bp-feat-t">{nb(post.title)}</h2>
        <p className="bp-feat-d">{nb(post.description)}</p>
        <div className="bp-pc-m"><span>{post.author}</span><span>{post.publishDate}</span><span>{post.readTime}</span></div>
        <span className="bp-feat-go">Read the article <span style={{ width: 18, display: 'inline-flex' }}><Arrow /></span></span>
      </div>
    </a>
  );
}
